import { useEffect, useRef } from 'react';
import lottie, { AnimationItem } from 'lottie-web';

const useLottieAnimation = (animationData: object) => {
  const animationContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let animation: AnimationItem | null = null;
    if (animationContainer.current && animationData) {
      lottie.destroy(); // Clear previous animation
      animation = lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    }

    return () => {
      if (animation) {
        animation.destroy(); // Cleanup animation on unmount
      }
    };
  }, [animationData]);

  return animationContainer;
};

export default useLottieAnimation;
